import * as React from "react";
import { projectLogo } from "./CustomHooks";

const BlurLoader = React.memo(({
    text = "Please wait...",
    imageUrl = `./images/${projectLogo()}`
}) => {
    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm z-50">
            <div className="relative text-center">
                {/* Spinner */}
                <div className="w-16 h-16 border-4 border-gray-200 border-t-teal-500 rounded-full animate-spin mx-auto mb-4"></div>

                {/* Logo */}
                <img
                    src={imageUrl}
                    alt="Loading..."
                    loading="eager"
                    className="w-40 h-40 object-contain mx-auto mb-0"
                />

                {/* Text */}
                <h3 className="text-white text-lg font-semibold tracking-wide">
                    {text}
                </h3>
            </div>
        </div>
    );
});

export default BlurLoader;
